import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CTABanner() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Professional screen repair and door installation service"
          className="w-full h-full object-cover object-center"
          src="https://storage.readdy-site.link/project_files/95272ccd-89f8-41e5-a90f-f2c2b48cc48a/38f924af-e81e-415b-91ea-bfed8882ed98_compressed_magnific_reframe-this-exact-photog_BmDbdUKoQR.webp"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 bg-black/25 z-[2]" />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block text-primary-500 text-xs font-bold uppercase tracking-[0.25em] border border-primary-500/40 rounded-full px-4 py-1 mb-4">
          {t('ctaBanner.badge')}
        </span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mt-3 leading-tight">
          {t('ctaBanner.title')}
        </h2>
        <p className="text-white/70 mt-5 text-base leading-relaxed max-w-xl mx-auto">
          {t('ctaBanner.description')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <Link
            to="/contact"
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-bold px-10 py-4 rounded-full text-sm transition-all cursor-pointer flex items-center gap-2 text-center"
          >
            <i className="ri-message-3-line w-5 h-5 flex items-center justify-center" />
            {t('ctaBanner.quoteBtn')}
          </Link>
          <a
            href="tel:+16574338533"
            className="whitespace-nowrap bg-accent-500 hover:bg-accent-600 text-black font-bold px-8 py-4 rounded-full text-sm transition-all cursor-pointer flex items-center gap-2 text-center"
          >
            {t('ctaBanner.callBtn')}
          </a>
        </div>
      </div>
    </section>
  );
}